import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: `${process.env.GATSBY_NOVADE_LITE_API_URL_SEA}/graphql`,
  cache: new InMemoryCache()
});

export default client;
